module.exports = __webpack_public_path__ + "img/Rectangle 61.b34610b4.svg";